module.exports = __webpack_public_path__ + "img/dark-Creative-demo.e22b2d6f.png";